import { render, staticRenderFns } from "./DocumentsBlock.vue?vue&type=template&id=7eaf230b&scoped=true"
import script from "./DocumentsBlock.vue?vue&type=script&lang=js"
export * from "./DocumentsBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eaf230b",
  null
  
)

export default component.exports